// French for the standing-facts zone of the client page. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Recorded — the previous value of {key} moved into its history': 'Consigné — la valeur précédente de {key} est passée dans son historique',
  'Fact recorded': 'Fait consigné',
  'Fact updated': 'Fait mis à jour',
  'Confirmed — {key} is operator-reviewed (audit log has the touch).': 'Confirmé — {key} a été contrôlé par l’opérateur (la piste d’audit en garde la trace).',
  '{key} retracted — the row stays in the history.': '{key} retiré — la ligne reste dans l’historique.',
  'Deleted — the previous value of {key} is current again': 'Supprimé — la valeur précédente de {key} est de nouveau actuelle',
  'Deleted {key}': '{key} supprimé',
  'as of {date}': 'en date du {date}',
  'source': 'source',
  'Recorded by the reconstruction agent — always yours to correct': 'Consigné par l’agent de reconstruction — toujours modifiable par vous',
  'agent': 'agent',
  'retracted': 'retiré',
  'no current value — {n} historical row': 'aucune valeur actuelle — {n} ligne historique',
  'no current value — {n} historical rows': 'aucune valeur actuelle — {n} lignes historiques',
  'Recorded by an agent pass, never confirmed by a human': 'Consigné lors d’une passe d’agent, jamais confirmé par un humain',
  'Held — a human stands behind this value': 'Soutenu — un humain se porte garant de cette valeur',
  'unconfirmed': 'non confirmé',
  'no date': 'sans date',
  'stated by {name}': 'déclaré par {name}',
  'no speaker attributed': 'aucun locuteur attribué',
  'extracted from the document — no speaker attributed': 'extrait du document — aucun locuteur attribué',
  '{n} earlier value': '{n} valeur antérieure',
  '{n} earlier values': '{n} valeurs antérieures',
  'Keep this agent-recorded value — one audited click': 'Conserver cette valeur consignée par l’agent — un clic audité',
  'Confirm': 'Confirmer',
  'Edit value, as-of, stated-by or quote': 'Modifier la valeur, la date, l’auteur ou la citation',
  'Edit': 'Modifier',
  'Retract — wrong or withdrawn; the row stays in the history': 'Retirer — erroné ou révoqué ; la ligne reste dans l’historique',
  'Retract': 'Retirer',
  'Delete — the previous value becomes current again': 'Supprimer — la valeur précédente redevient actuelle',
  'Delete this fact': 'Supprimer ce fait',
  'Delete': 'Supprimer',
  'Stated by': 'Déclaré par',
  'Quote — verbatim from the source document, or empty': 'Citation — mot pour mot depuis le document source, ou vide',
  'Saving…': 'Enregistrement…',
  'Save': 'Enregistrer',
  'Cancel': 'Annuler',
  'Delete this historical row — the chain re-links around it': 'Supprimer cette ligne historique — la chaîne se referme autour d’elle',
  'What we currently know': 'Ce que nous savons actuellement',
  '{n} standing fact': '{n} fait',
  '{n} standing facts': '{n} faits',
  '{n} unconfirmed': '{n} non confirmés',
  'Show only the values an agent recorded and nobody has confirmed': 'N’afficher que les valeurs qu’un agent a consignées et que personne n’a confirmées',
  'Only unconfirmed ({n})': 'Seulement non confirmés ({n})',
  'The catalog’s standing fields that hold no value yet — the briefing form, with its blanks': 'Les champs permanents du catalogue qui n’ont pas encore de valeur — le formulaire de briefing, avec ses cases vides',
  'Hide the empty fields': 'Masquer les champs vides',
  'Show the empty fields': 'Afficher les champs vides',
  'Add fact': 'Ajouter un fait',
  'Nothing recorded yet — run a reconstruct pass. Facts are the latest known instance of each negotiable — fee, scope bound, lead time — each with its as-of date and source document.': 'Rien n’est encore consigné — lancez une passe de reconstruction. Les faits sont le dernier état connu de chaque point négociable — honoraires, limite de périmètre, délai de mise en œuvre — chacun avec sa date de référence et son document source.',
  'Money': 'Finances',
  'Timing': 'Calendrier',
  'Solution': 'Solution',
  'People': 'Personnes',
  'Relationship': 'Relation',
  'Facts recorded under novel keys — outside the standing catalog': 'Faits consignés sous des clés inédites — hors du catalogue permanent',
  'Client-specific': 'Spécifique au client',
  'Record a fact': 'Consigner un fait',
  'Key — a standing catalog field; reuse an existing key to supersede its value': 'Clé — un champ permanent du catalogue ; réutilisez une clé existante pour remplacer sa valeur',
  'Client-specific (novel key) — standing fields have priority; tick only when none fits': 'Spécifique au client (clé inédite) — les champs permanents ont priorité ; ne cocher que si aucun ne convient',
  'Value — as stated, with units and qualifiers': 'Valeur — telle que déclarée, avec unités et qualificatifs',
  '18.5k CHF/yr excl. VAT, final offer': '18.5k CHF/an hors TVA, offre finale',
  'As of': 'En date du',
  'Source document — mandatory; where the value is stated': 'Document source — obligatoire ; où la valeur est indiquée',
  '— pick a document —': '— choisir un document —',
  'Quote — optional, but must be verbatim from the document': 'Citation — facultative, mais doit être mot pour mot depuis le document',
  'Checked character-for-character against the document’s extracted text — a paraphrase is rejected.': 'Vérifiée caractère par caractère par rapport au texte extrait du document — une paraphrase est rejetée.',
  'Recording…': 'Consignation…',
  'Record fact': 'Consigner le fait',
  'Delete fact': 'Supprimer le fait',
  'Deleting…': 'Suppression…',
  'Delete this value of {key}?': 'Supprimer cette valeur de {key} ?',
  'The previous value in the chain becomes current again.': 'La valeur précédente de la chaîne redevient actuelle.',
  'The rest of the chain re-links around it.': 'Le reste de la chaîne se referme autour d’elle.',
  'The audit log keeps the record.': 'La piste d’audit conserve la trace.',
}, 'ClientFactsPanel');
